module.exports = __webpack_public_path__ + "static/media/step-2-id.ddee35cc.jpg";